import { Component, OnInit } from '@angular/core';
import { ReportAuditRecord } from '../../models/report.model';
import { ReportdashboardService } from '../../services/reportdashboard.service';

@Component({
  selector: 'app-reporthistory',
  templateUrl: './reporthistory.component.html',
  styleUrls: ['./reporthistory.component.css']
})
export class ReporthistoryComponent implements OnInit {
  reportAuditTrailData:ReportAuditRecord[];
  
  constructor(private reportDashboardService:ReportdashboardService) { }

  ngOnInit() {

  }

  ShowReportHistoryDlg(Id:any)
  {
    this.reportDashboardService.getReportHistoryById(Id).subscribe(
      (data:ReportAuditRecord[])=>{
        //console.log(data);
        this.reportAuditTrailData =data;
      });
  }

}
